import { filter, map } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { isFiat } from '@sparling/financial-common'
import { RootEpic } from '../types'
import { getAllInstrumentsSuccess, setFiats } from '../actions'

const computeFiats = (underliers: string[]): string[] => {
  const out = new Set<string>()
  underliers.forEach((u) => {
    const U = (u || '').replace('/', '').toUpperCase()
    if (U.length < 3) return
    const suf3 = U.slice(-3)
    if (isFiat(suf3)) out.add(suf3)
  })
  return Array.from(out.values())
}

export const buildFiatsFromAssetsEpic: RootEpic = (action$) => {
  return action$.pipe(
    filter(isActionOf(getAllInstrumentsSuccess)),
    map(({ payload }) => {
      const underliers = (payload || []).map((i) => i.underlier || '')
      const fiats = computeFiats(underliers)
      return setFiats(fiats)
    }),
  )
}

export default [buildFiatsFromAssetsEpic]
